// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/boca1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: bottom;
  background-repeat: no-repeat; }
`, "",{"version":3,"sources":["webpack://./src/styles/DescriptionSection.scss"],"names":[],"mappings":"AAAA;EACI,yDAAsD;EACtD,2BAA2B;EAC3B,4BAA4B,EAAA","sourcesContent":[".main {\n    background-image: url(\"../../public/assets/boca1.png\");\n    background-position: bottom;\n    background-repeat: no-repeat;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
